import React from "react";
import { Container } from "@mui/material";
import PageBanner from "../muiCommonComponent/pageBanner";
import Home from "./home";
import NewMain from "../headerone/newMain";
import WidgetsMenu from "../muiCommonComponent/menuWidgets";
import Studentshub from "./studentshub";
import Initiative from "./initiative";
import Alumni from "./alumni";
import Faculty from "./faculties/facultyList";
import Placement from "./training&placement";
import Research from "./r&d";
import Lab from "./lab";  
import { useParams } from "react-router-dom";
import BALLB from './SOL/ballb'
import BBALLB from "./SOL/bballb";
import LLB from "./SOL/llb";
import LLM from "./SOL/llm";
import FacultyDetail from "../facultydetail/main";  
import ZimbabweDayCelebration from "./events/ZimbabweDayCelebration";
import PartitionDayObservance from "./events/PartitionDayObservance";
import InductionProgrammeDeeksha2024 from "./events/InductionProgrammeDeeksha2024";
import TeachersDayCelebrationLawDepartment from "./events/TeachersDayCelebrationLawDepartment";
import ConstitutionDayCelebration from "./events/ConstitutionDayCelebration";
import ReportHumanRightsDayCelebration from "./events/ReportHumanRightsDayCelebration";
import BhartiyaBhashaUtsavCelebration from "./events/BhartiyaBhashaUtsavCelebration";
import ReportRoadSafetyProgram from "./events/ReportRoadSafetyProgram";
import ConsumerAwarenessProgramme from "./events/ConsumerAwarenessProgramme";
import VoersDayCelebrationLawDepartment from "./events/VoersDayCelebrationLawDepartment";
import LegalAwarenessCamp from "./events/LegalAwarenessCamp";
import CourtVisitReport from "./events/CourtVisitReport";
import IntercollegesportsCompetition from "./events/IntercollegesportsCompetition";

const SOETHome=()=>{
    const { screenname } = useParams();
    console.log('screenname::::::::::::',screenname)
    const screensName=()=>{
        let screen=''
        if(screenname=='home'){
            screen=Home()
        }
       else if(screenname=='student-hub'){
            screen=Studentshub()
        }else if(screenname=='intiative'){
            screen=Initiative()
        }
        else if(screenname=="our-alumi"){
            screen=Alumni()
        }
        else if(screenname=='t-p'){
            screen=Placement()
        }else if(screenname=='r-d'){
            screen=Research()
        }
        else if(screenname=="laboratory"){
            screen=Lab()
        }
        else if(screenname=='ba-llb'){
            screen=BALLB()
        }else if(screenname=='bba-llb'){
            screen=BBALLB()
        }
        else if(screenname=="llb"){
            screen=LLB()
        }
        else if(screenname=='llm'){
            screen=LLM()
        }
        else if(screenname=='faculties'){
            screen=Faculty()
        }
        else if(screenname=="facultyDetail"){
            screen=FacultyDetail()
        } 
        else if(screenname=="zimbabwe_day_celebration"){
            screen=ZimbabweDayCelebration() 
        }
        else if(screenname=="partition_day_observance_14_august_2024"){
            screen=PartitionDayObservance() 
        }
        else if(screenname=="induction_programme_deeksha_aarambh_2024"){
            screen=InductionProgrammeDeeksha2024() 
        } else if(screenname=="teachers_day_celebration_law_department"){
            screen=TeachersDayCelebrationLawDepartment() 
        }else if(screenname=="constitution_day_celebration_26th_november_2024"){
            screen=ConstitutionDayCelebration() 
        }else if(screenname=="report_human_rights_day_celebration"){
            screen=ReportHumanRightsDayCelebration() 
        }else if(screenname=="bhartiya_bhasha_utsav_celebration"){
            screen=BhartiyaBhashaUtsavCelebration() 
        }else if(screenname=="report_road_safety_program_date_10th_january_2025"){
            screen=ReportRoadSafetyProgram() 
        }else if(screenname=="consumer_awareness_programme"){
            screen=ConsumerAwarenessProgramme() 
        }else if(screenname=="voters_day_celebration_law_department"){
            screen=VoersDayCelebrationLawDepartment() 
        }else if(screenname=="legal_awareness_camp"){
            screen=LegalAwarenessCamp() 
        }else if(screenname=="court_visit_report"){
            screen=CourtVisitReport() 
        }else if(screenname=="mvn_university_students_excel_at_inter_college_sports_competition"){
            screen=IntercollegesportsCompetition() 
        }








       
        return screen
    }
    const headerMenus = [
        { mainHeader: 'Home ', path: '/school-of-law/home', subHeader: [] },
        { mainHeader: 'About SOL', path: '/school-of-law/home', subHeader: [] },
        { mainHeader: 'Academic Courses ',path: '#', subHeader: [
            { title: 'B.A.LL.B. ', path: '/school-of-law/ba-llb', },
            { title: 'B.B.A.LL.B.', path: '/school-of-law/bba-llb', },
            { title: 'LL.B.', path: '/school-of-law/llb', },
            { title: 'LL.M.', path: '/school-of-law/llm', },
        ] },
        { mainHeader: 'Laboratories ', path: '/school-of-law/laboratory', subHeader: [] },
        { mainHeader: 'Faculty', path: '/school-of-law/faculties', subHeader: [] },
        { mainHeader: 'R & D', path: '/school-of-law/r-d', subHeader: [] },
        { mainHeader: 'T & P', path: '/school-of-law/t-p', subHeader: [] },
        { mainHeader: 'Student Hub', path: '/school-of-law/student-hub', subHeader: [] },
        { mainHeader: 'Our Alumni', path: '/school-of-law/our-alumi', subHeader: [] },
        { mainHeader: 'Initiative ', path: '/school-of-law/intiative', subHeader: [] },
    ]
return(<>
<NewMain/>
<WidgetsMenu headerMenus={headerMenus}/>
<PageBanner bannerUrl={"/assets/img/SOL/sol.jpg"}/>
<Container>
{screensName()}
</Container>
</>)
}
export default SOETHome;
